import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'
window.bootstrap = bootstrap; // Attach to window for global access

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// Import our global CSS
import './assets/css/style.css'

// Import Echo service for real-time updates
//import initEcho from './services/echo'

// Initialize Echo for real-time updates
//initEcho()

// Import toast plugin
import Toast from './plugins/toast'

const app = createApp(App)

// Add global properties (similar to Vue 2's Vue.prototype)
app.config.globalProperties.$appName = 'HCET Queue Management System'

// Configure app with router and store
app.use(router)
   .use(store)
   .use(Toast)
   .mount('#app')
